import { nanoid } from 'nanoid'
import { createSelector } from 'reselect'
import { ConversationElement, ConversationExerciseData, ExerciseType } from '../Exercise'
import { AppState } from 'store/types'
import { Activity, ActivityType, ExerciseActivity } from './Lesson.types'

export const selectLessonsTemplates = (state: AppState) => state.lesson.lessonsTemplates

export const selectActiveLessons = (state: AppState) => state.lesson.activeLessons

export const selectLessonInstance = (state: AppState) => state.lesson.lessonInstance

export const selectLessonInstanceWithConversationSummaries = createSelector(selectLessonInstance, (routine) => {
  if (!routine) return null

  return {
    ...routine,
    activities: routine.activities.map((activity) => {
      const isConversationExercise =
        activity?.type === ActivityType.Exercise && activity.exercise.type === ExerciseType.Conversation

      if (isConversationExercise) {
        const castedActivity = activity as ExerciseActivity
        const exerciseData = castedActivity.exercise.data as ConversationExerciseData

        const conversationElementsWithSummary: ConversationElement[] = [
          ...exerciseData.conversationElements.map((conversationElement) => ({ ...conversationElement, id: nanoid() })),
          {
            id: nanoid(),
            videoUrl: '',
            gapIndices: [],
            isSummary: true
          }
        ]

        return {
          ...castedActivity,
          exercise: {
            ...castedActivity.exercise,
            data: { ...exerciseData, conversationElements: conversationElementsWithSummary }
          }
        } as Activity // returned object is a Conversation ExerciseActivity
      } else return activity
    })
  }
})
